export default "__VITE_ASSET__b7636085__"